module.exports = __webpack_public_path__ + "static/media/clydeEdnaBabyKim.1076dd7c.png";